(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["nega-related"]) return;
  try {
    
  const loadRelated = async (element) => {
    if (element.dataset.loaded) return;
    element.dataset.loaded = 'true';
    try {
      const response = await fetch(element.dataset.url);
      if (!response.ok) return;
      const document = new DOMParser().parseFromString(await response.text(), 'text/html');
      const content = document.querySelector('.nega-related');
      if (content?.innerHTML.trim()) element.innerHTML = content.innerHTML;
    } catch { }
  };
  const mountRelated = () => document.querySelectorAll('.nega-related').forEach(element => {
    const observer = new IntersectionObserver(entries => {
      if (entries.some(entry => entry.isIntersecting)) { observer.disconnect(); loadRelated(element); }
    }, {rootMargin: '300px'});
    observer.observe(element);
  });
  mountRelated();
  document.addEventListener('shopify:section:load', mountRelated);

  } catch(e) { console.error(e); }
})();
})();
